import React from "react";

import { be } from "../../../../utils/bliss";
import { isMobile } from "../../../../utils/utils";

import Headline from "../../../../components/headline/headline";
import RewardInfo from "../../../../components/rewardInfo/rewardInfo";

const MODULE_NAME = "ProjectDetailScreen";

const FinancingState = ({ project, myRef }) => (
  <div>
    {!isMobile() && (
      <div
        ref={myRef}
        style={{
          backgroundColor: "white",
          margin: "-65px -1500px 0 -1500px",
          padding: "65px 1500px"
        }}
      />
    )}
    {isMobile() && (
      <div
        ref={myRef}
        style={{
          height: "5px",
          backgroundColor: "white",
          margin: "0 -1500px",
          padding: "30px 1500px 0 1500px"
        }}
      />
    )}
    {project.rewards && project.rewards.length > 0 && (
      <div className={be(MODULE_NAME, "rewardsBackground")}>
        <div className="row ml-2 mb-5 pb-2">
          <Headline bold component="h2" greenReward pageSub>
            Vyberte formu příspěvku
          </Headline>
        </div>
        <div className="row">
          {project.rewards.map(reward => (
            <div key={reward.id} className="col-sm-6 col-lg-4">
              <RewardInfo reward={reward} />
            </div>
          ))}
        </div>        
        <div className="clearfix" />
      </div>
    )}
  </div>
);

export default FinancingState;
